import { useRef, useState } from "react";
import { Box, CircularProgress, colors } from "@material-ui/core";
import { IoMdClose, IoIosAttach } from "react-icons/io";
import _ from "lodash";

import { useStyles } from "./SquareImageChooser.style";

export interface SquareImageChooserProps {
  defaultFile?: any;
  onImageSelected?: (file: any) => void;

  externalLabel?: boolean,
  label?: string;
  height?: number;
}

export function SquareImageChooser(props: SquareImageChooserProps) {
  const classes = useStyles(props);
  const { defaultFile, onImageSelected, label, externalLabel } = props;
  const inputId = _.uniqueId("image-chooser-");
  const imageInputRef = useRef();
  // State
  const [file, setFile] = useState(defaultFile);
  const [progress, setProgress] = useState(false);

  const handleUpload = (event) => {
    let newFile = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(newFile);

    setProgress(true);

    // Read to display
    reader.onloadend = function (e) {
      setTimeout(() => {
        setFile(reader.result);
        setProgress(false);
      }, 1000);
    };

    if (onImageSelected !== null && onImageSelected !== undefined) {
      onImageSelected(event.target.files[0]);
    }
  };

  const handleRemoveImage = () => {
    setFile(null);
    // @ts-ignore
    imageInputRef.current.value = "";

    if (onImageSelected !== null && onImageSelected !== undefined) {
      onImageSelected(null);
    }
  };

  const renderAction = () => {
    if (progress) {
      return (
        <div className="progressWrapper">
          <Box component="span" className="loader">
            <CircularProgress color="secondary" size={16} thickness={4} />
          </Box>
        </div>
      );
    } else {
      if (file) {
        return (
          <div className="overlayWrapper">
            <div className="overlay" />
            <Box
              component="span"
              className="removeAction"
              onClick={handleRemoveImage}
            >
              <IoMdClose color={colors.common.white} size={14} />
            </Box>
          </div>
        );
      }
    }

    return (
        <>
          <label htmlFor={inputId}>
            <Box
                component="div"
                className="actionWrapper"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
              <Box component="div" display="flex" alignItems="center">
                <IoIosAttach size={24} />
                <Box component="span" display="inline-block" ml={1}>
                  {label}
                </Box>
              </Box>
            </Box>
          </label>
        </>
    );
  };

  return (
    <Box
      className={classes.squareWrapper}
      style={{
        backgroundImage: `url(${file ? file : "none"})`,
      }}
    >
      <div className="content">
        <input
          accept="image/*"
          ref={imageInputRef}
          className={classes.input}
          id={inputId}
          type="file"
          onChange={handleUpload}
        />
        {renderAction()}
      </div>
    </Box>
  );
}

SquareImageChooser.defaultProps = {
  height: 86,
};
